module.exports = __webpack_public_path__ + "static/media/LockSimpleOpenActive.526dd60a.svg";